import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ItemCard from "../common/ItemCard";
import { useEmbedded } from "../../hooks/useEmbedded";

const CatlogCard = ({ item, onItemAction, isEmbedded: isEmbeddedProp }) => {
  const navigate = useNavigate();
  const isEmbeddedFromHook = useEmbedded();
  const isEmbedded =
    isEmbeddedProp !== undefined ? isEmbeddedProp : isEmbeddedFromHook;
  const userRole = item.currentUserRole || 'learner';
  const isCatlog = item.type === "course";
  const pathPrefix = isEmbedded ? "/embed" : "";
  const viewPath = `${pathPrefix}${
    item.type === "course"
      ? `/learner/course/${item.id}`
     : item.type === "certificate"
      ? userRole === 'author'
      // ? `/certificates/preview/${item.id}`
      //  : `/learner/certificate/${item.id}`
      : `/learner/lpath/${item.id}`
  }`;

  const getButtonText = () => {
    const isEnrolled = item.isEnrolled ?? false;
    if (!isEnrolled) return "View";
    if (item.progress === 100) return "Revisit";
    else if (item.progress === 0) return "Start";
    else if (item.progress > 0 && item.progress < 100) return "Continue";
    return "Start";
  };

  // Adapt the item structure to match what ItemCard expects
  const adaptedItem = {
    id: item.id,
    name: item.name,
    title: item.name, // Ensure both name and title are available
    description: item.description,
    cover_picture: item.cover_picture,
    bookmarked: item.bookmarked || item.isBookmarked,
    status: item.status,
    createdAt: item.created_at,
    createdBy: item.user_id,
    progress: item.progress || 0,
    learnerPath: viewPath,
    jobAids_url: item.jobAids_url,
    customButton: {
    text: getButtonText(),
      onClick: (e) => {
        e.stopPropagation();
        navigate(viewPath);
      }
    }
  };

  return (
    <ItemCard
      item={adaptedItem}
      onItemAction={onItemAction}
        itemType={
          item.type === 'course'
          ? 'course'
          : item.type === 'learning path'
          ? 'learningPath'
          : item.type === 'certificate'
          ? 'certificate'
          : 'job aid'
        }
      className="my-learning-card"
    />
  );
};

export default CatlogCard;